/**
 * Cookie Dismissal Action
 * Triggered by: arc:action:cookieDismissal
 * 
 * Closes a specified element and sets a dismissal cookie
 */

export const runCookieDismissal = async (data = {}) => {
    try {
        const { actionName } = data;
 
        let parsedElementId = actionName && actionName.startsWith('cookieDismissal') ? actionName.split('cookieDismissal-')[1] : null;
        
        let parsedCookieName = `dismissal-${parsedElementId}`;
        
  
        const targetElement = document.getElementById(parsedElementId);
        let cookieValue = 'true';

        if (targetElement) {
            const classList = Array.from(targetElement.classList);
            const dismissalClass = classList.find(className => className.startsWith('dismissal-'));

            if (dismissalClass) {
                cookieValue = dismissalClass;
            }
            
            targetElement.style.transition = 'opacity 0.3s ease-out, max-height 0.3s ease-out';
            targetElement.style.opacity = '0';
            targetElement.style.maxHeight = '0';
            targetElement.style.overflow = 'hidden';
            

            setTimeout(() => {
                if (targetElement.parentNode) {
                    targetElement.parentNode.removeChild(targetElement);
                }
            }, 300);
        }

    
        const expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + 7);
        
        const cookieString = `${parsedCookieName}=${cookieValue}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
        
        document.cookie = cookieString;

        window.dispatchEvent(new CustomEvent('arc:action:cookieDismissal:success', {
            detail: {
                result: {
                    elementId: parsedElementId,
                    elementClosed: !!targetElement,
                    cookieSet: parsedCookieName,
                    expiryDate: expiryDate.toISOString()
                }
            }
        }));

        return {
            success: true,
            elementId: parsedElementId,
            elementClosed: !!targetElement,
            cookieSet: parsedCookieName,
            expiryDate: expiryDate.toISOString()
        };

    } catch (error) {
        console.error('Cookie dismissal action error:', error);
        
        window.dispatchEvent(new CustomEvent('arc:action:cookieDismissal:error', {
            detail: {
                error: error.message
            }
        }));

        return {
            success: false,
            error: error.message
        };
    }
};

export default runCookieDismissal;